// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [];

module.exports = angular.module('bench.ui.constants', deps).factory('blConstants', () => ({
  KEY_CODE: {
    ENTER: 13,
    ESCAPE: 27,
    END: 35,
    LEFT_ARROW: 37,
    UP_ARROW: 38,
    RIGHT_ARROW: 39,
    DOWN_ARROW: 40,
    TAB: 9,
    L: 76,
  },
}));
